<!--
 * @Description:主管陪访（共同销售）
 * @Author: zz
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        :columns="columns"
        tableId="lbusupervisorAccompanyingVisit"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="客户负责人">
              <UserSelect permission v-model:value="queryForm.seller"/>
            </dc-form-item>
            <dc-form-item label="创建人">
              <UserSelect permission v-model:value="queryForm.createBy"/>
            </dc-form-item>
            <dc-form-item name="startTime" label="创建时间">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime"/>
            </dc-form-item>
            <dc-form-item name="id" label="ID">
              <a-input v-model:value="queryForm.id" allowClear placeholder="请输入"/>
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <a-button
              v-permission="'lbu_accompanying_visit_edit_btn'"
              type="link"
              @click="handleEdit(record)"
              :workCode="record.createBy"
            >编辑
            </a-button
            >
            <a-button
              v-permission="'lbu_accompanying_visit_del_btn'"
              type="link"
              @click="handleDelete(record)"
              :workCode="record.createBy"
              @success="success"
            >删除
            </a-button
            >
            <a-button
              v-permission="'lbu_accompanying_visit_comment_btn'"
              type="link"
              @click="commentRow(record)"
            >评论
            </a-button
            >
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd(record)" @success="success"
                    v-permission="'lbu_accompanying_visit_add'">新增
          </a-button>
          <ExportButton appId="cos_lbu" taskType="309" :search="queryForm"
                        v-permission="'lbu_accompanying_visit_export'">导出
          </ExportButton>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { accompanyingVisitDelete, accompanyingVisitList } from '@/api/yuntuSales/superivisorAccompanyingVisit'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { AccompanyingVisitItem, AccompanyingVisitListParams } from '@/typings/api/yuntuSales'
import { cloneDeep } from 'lodash-es'

const loading = ref(false)

const router = useRouter()
const route = useRoute()
const tableRef = ref()

const selectedRows = ref<AccompanyingVisitItem[]>([])
const queryForm = ref<AccompanyingVisitItem>({})
// 获取列表
const fetch = async (queryForm: AccompanyingVisitListParams, callBack: (res: any) => void) => {
  accompanyingVisitList(queryForm).then((res) => {
    callBack(res)
  })
}
const onSelectChange = (selectedRowKeys: string[], rows: AccompanyingVisitItem[]) => {
  selectedRows.value = rows
}
// 编辑
const handleEdit = (record: AccompanyingVisitItem) => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/edit',
    query: {
      id: record.id
    }
  })
}
// 删除
const handleDelete = (record: AccompanyingVisitItem) => {
  Modal.delete({
    name: record.id,
    onOk() {
      loading.value = true
      accompanyingVisitDelete({
        id: record.id
      })
        .then((res) => {
          tableRef.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
// 新增
const handleAdd = () => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/add'
  })
}
// 评论
const commentRow = (row: AccompanyingVisitItem) => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/comment',
    query: {
      id: row.id
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 36
const columns = computed(() => [
  {
    title: 'ID',
    dataIndex: 'id',
    cosType: 'link',
    path: '/lbu/supervisorAccompanyingVisit/view',
    query: ['id']
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '跟进记录',
    dataIndex: 'startTime'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName'
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '陪访过程',
    dataIndex: 'process'
  },
  {
    title: '后续跟进',
    dataIndex: 'followUp'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuSupervisorAccompanyingVisit' }
</script>

<style scoped></style>
